export const SET_THICKNESS = 'SET_THICKNESS';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_CELL_TYPE = 'SET_CELL_TYPE';
export const SET_OFFSET = 'SET_OFFSET';
export const SET_STROKE_VISIBLE = 'SET_STROKE_VISIBLE';

export const BATCH_UPDATE_GENERATIONS = 'BATCH_UPDATE_GENERATIONS';


// WEBPACK FOOTER //
// ./src/core/generations/action-types.js